import _ from "lodash"

export default {
	INTERNET_STATUS: function(state, t) {
	    state.internetStatus = t
	},
	DISPLAY_LOADING_SCREEN: function(state, t) {
	    var a = document.getElementsByClassName("home-loadding")[0];
	    if (t) {
	    	a.classList.add("show");
	    	a.classList.remove("hide");
	    }else{
	    	a.classList.remove("show");
	    	a.classList.add("hide");
	    }
	},
	INTERNET_CONNECTION_STATUS: function(state, t) {
	    state.internetStatus = t
	},
	APPEND_TOP_GAME: function(state, t) {
	    state.topGames = t
	},
	SET_CONTENTS: function(state, t){
		state.contents = t
	},
	SET_NEWER: function(state, t){
		state.isNewer = t
	},
	APPEND_TOP_HOME: function(state, t) {
	    state.topHomes = t
	},
	SET_HISTORY: function(state, t) {
		state.history = t
	},
	SET_GENDER: function(state, t) {
		state.gender = t
	},
	REMOVE_GAME_BYID: function(state, t) {
		var c = state.topGames
		_.remove(c, function(e){
			return e.id == t
		})
		state.topGames = [...c]
	}
}